import { createRouter, createWebHashHistory } from "vue-router";
import Download from "@/view/download/DownloadView.vue";

const routes = [
  { path: "/", name: "", component: Download },
  { path: "/home", name: "Home", component: Download },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
